import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext, useState } from 'react';
import { AppContext } from '../../../../../state/app.state';
import { isIosMobile, isMobile } from '../../../../../utils/app.helper';
import { polygonMeasurements } from '../../../PolygonPreview/PolygonPreview';

type SvgMappingCanvasProps={
    onCanvasClick?: () => void;
    disableObjectTouchInteraction: boolean
};

const SvgMappingCanvas: React.FC<SvgMappingCanvasProps> = ({ onCanvasClick, disableObjectTouchInteraction }): ReactElement => {
    const { state, presentationState } = useContext(AppContext);
    const [touchStart, setTouchStart] = useState<Date>();

    const onBackgroundMouseEnter = (): void => {
        presentationState?.activePreview && Array.from(document.getElementsByClassName('bv-mapping-fade')).forEach(o => {
            o.classList.remove('bv-mapping-fade');
        });
        state?.setPreviewObjectId(undefined);
        presentationState?.setActivePreview(false);
    };

    return useObserver(() => (
        <>

            <defs>
                {state?.currentViewMappingObjects?.map(o => {
                    const measure = polygonMeasurements(o.polycords);

                    return <mask key={`mask-${o.id}`} id={`object-mask-${o.id}`}>
                        <rect fill="white" height="100%" width="100%"></rect>
                        <polygon
                            points={o.polycords.join(',')}
                            fill={'black'}
                            style={{ transformOrigin: `${measure.xMid}% ${measure.yMid}%` }}
                            vectorEffect={'non-scaling-stroke'}/>
                    </mask>;
                })}
            </defs>
            {<polygon
                onTouchStart={(e): void => {
                    if (disableObjectTouchInteraction) return;
                    setTouchStart(new Date());
                    presentationState?.activePreview && Array.from(document.getElementsByClassName('bv-mapping-fade')).forEach(o => {
                        o.classList.remove('bv-mapping-fade');
                    });
                }}
                onMouseEnter={isIosMobile() ? undefined : onBackgroundMouseEnter}
                onTouchEnd={(e):void => {
                    if (disableObjectTouchInteraction) return;

                    if (touchStart && presentationState?.activePreview && (Math.abs(new Date().getTime() - touchStart.getTime())) < 100) {
                        onCanvasClick && onCanvasClick();
                        isIosMobile() && onBackgroundMouseEnter();
                    }

                    else {
                        presentationState?.activePreview && Array.from(document.getElementsByClassName('bv-polygon')).forEach(o => {
                            const isSelected = Array.from(o.classList.values()).find(c => c.indexOf('--selected') !== -1)?.length;

                            if (!isSelected)
                                o.classList.add('bv-mapping-fade');
                        });
                    }
                    setTouchStart(undefined);
                }}
                className={'bv-svg-mapping-background'}
                onClick={(evt) => evt.target === evt.currentTarget && onCanvasClick && onCanvasClick()}
                points={'0,0,0,100,100,100,100,0'}
                fill={presentationState?.activePreview && isMobile() ? 'rgba(200,200,200,0.6)' : 'transparent'}
                mask={state?.currentViewMappingObjects?.find(({ mappingEntityId }) => state.isCurrentPreviewObject(mappingEntityId)) && `url(#object-mask-${state.currentViewMappingObjects?.find(({ mappingEntityId }) => state.isCurrentPreviewObject(mappingEntityId))?.id })`}
            />}
        </>
    ));
};


export default SvgMappingCanvas;